module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1NDIgNTQyIj4KICA8ZGVmcz48c3R5bGU+LmF7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz4KICA8cG9seWdvbiBjbGFzcz0iYSIgcG9pbnRzPSIwIDU0MiAwIDQ2OC40MyAxNTUuNzQgMCAxODAuNTEgMCAwIDU0MiIvPgogIDxwb2x5Z29uIGNsYXNzPSJhIiBwb2ludHM9IjU0MS44OSA0NjYuNjQgNTQyIDU0MiAzNjEuNDQgMCAzODUuNzggMCA1NDEuODkgNDY2LjY0Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/images/symbol.svg
// module id = 136
// module chunks = 168707334958949